import { createSlice } from "@reduxjs/toolkit";
import { ContrataSeguro } from "../models/contrataSeguro";

const initialState: ContrataSeguro = {
  requestInsurance: false,
};

export const ContrataSeguroState = createSlice({
  name: "ContrataSeguro",
  initialState,
  reducers: {
    setRequestInsurance: (state, action) => {
      return action.payload;
    }
  }
});

export const { setRequestInsurance } = ContrataSeguroState.actions;

export default ContrataSeguroState.reducer;
